module.exports = __webpack_public_path__ + "img/m_top_bg.4dd402ac.png";